import { GameData } from '../game/types';
import { BrancheFlorale, FleurCoin } from '../components/Florals';

export default function Attente({ data }: { data: GameData }) {
  return (
    <div className="min-h-screen bg-white flex flex-col relative overflow-hidden" data-testid="attente-screen">
      <FleurCoin className="absolute top-3 right-3 w-14 h-14 opacity-80" />
      <main className="flex-1 flex flex-col items-center justify-center px-8 text-center max-w-md w-full mx-auto">
        <p className="petit-cap anim-apparition">{data.config.lieu} · {data.config.dateMariage}</p>
        <h1 className="font-script text-encre text-6xl leading-tight mt-4 anim-apparition">Un peu de patience…</h1>
        <p className="text-texte leading-relaxed mt-6 anim-apparition" style={{ animationDelay: '0.15s' }}>
          Vous avez trouvé le chemin avant l'heure, félicitations. Mais le jeu ne s'ouvrira
          qu'au signal des mariés, pendant le vin d'honneur.
        </p>
        <p className="text-sm text-encre-clair mt-4 anim-apparition" style={{ animationDelay: '0.3s' }}>
          Gardez cette page précieusement : elle s'ouvrira d'elle-même le moment venu.
        </p>
      </main>
      <div className="flex justify-center pb-10">
        <BrancheFlorale className="w-52" />
      </div>
    </div>
  );
}
